import { useEffect } from 'react';
import { useNotificationsStore } from '../store';

const BASE_TITLE = 'Restroos Dashboard';

/**
 * While the tab is hidden, prefix `document.title` with the unread count
 * so owners notice incoming orders from another tab. Restores the title
 * when the tab regains focus.
 */
export function useTabTitleCounter() {
  const unreadCount = useNotificationsStore((s) => s.unreadCount);

  useEffect(() => {
    const baseTitle = document.title.replace(/^\(\d+\)\s*/, '') || BASE_TITLE;

    const update = () => {
      if (document.hidden && unreadCount > 0) {
        document.title = `(${unreadCount > 99 ? '99+' : unreadCount}) ${baseTitle}`;
      } else {
        document.title = baseTitle;
      }
    };

    update();
    document.addEventListener('visibilitychange', update);
    return () => {
      document.removeEventListener('visibilitychange', update);
      document.title = baseTitle;
    };
  }, [unreadCount]);
}
